var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrgChartFalcomHoldingEn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 720,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1280,
    height: 720
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 32,
    width: 1081,
    height: 588
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 31,
    width: 1081,
    height: 589
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1280,
    height: 720,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 1280 0 1280 720 0 720Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 0.0533333 72.9922",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 -1 767.5 393.492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.5 292.5 698.5 292.5 698.5 322.5 592.5 322.5 592.5 292.5Z",
    stroke: "#528CC1",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "#1E2945",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 11,
    transform: "translate(616.619 304)"
  }, "Nom &amp; Rem ", /*#__PURE__*/React.createElement("tspan", {
    fontSize: 11,
    x: 2.07996,
    y: 12
  }, "Committee"), /*#__PURE__*/React.createElement("tspan", {
    fontWeight: 700,
    fontSize: 20,
    x: -569.768,
    y: -193
  }, "FALCOM Holding Organization Structure")), /*#__PURE__*/React.createElement("path", {
    d: "M876.5 365.5 876.5 443.388",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    strokeDasharray: "1.33333 1.33333",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.5 443.5 877.446 443.5",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    strokeDasharray: "1.33333 1.33333",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 0.000104987 17.3328",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 -1 641.5 292.833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.5 292.5 544.5 292.5 544.5 322.5 450.5 322.5 450.5 292.5Z",
    stroke: "#528CC1",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "#1E2945",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 11,
    transform: "translate(457.734 304)"
  }, "Strategic Planning ", /*#__PURE__*/React.createElement("tspan", {
    fontSize: 11,
    x: 14.7466,
    y: 11
  }, "Committee")), /*#__PURE__*/React.createElement("path", {
    d: "M497.5 290.819 497.5 275.5",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 0.000104987 203.555",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 -1 559.5 392.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.5 488.5 345.5 505.382",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.5 291.5 436.5 291.5 436.5 321.5 366.5 321.5 366.5 291.5Z",
    stroke: "#528CC1",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "#1E2945",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 11,
    transform: "translate(378.934 303)"
  }, "Executive ", /*#__PURE__*/React.createElement("tspan", {
    fontSize: 11,
    x: -3.75333,
    y: 12
  }, "Committee")), /*#__PURE__*/React.createElement("path", {
    d: "M401.5 290.264 401.5 274.5",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.5 504.5 597.5 504.5 597.5 531.5 520.5 531.5 520.5 504.5Z",
    stroke: "#528CC1",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "#1E2945",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 11,
    transform: "translate(546.725 514)"
  }, "Legal ", /*#__PURE__*/React.createElement("tspan", {
    fontSize: 11,
    x: -16.2534,
    y: 12
  }, "Department")), /*#__PURE__*/React.createElement("path", {
    d: "M759.5 570.5 834.5 570.5 834.5 597.5 759.5 597.5 759.5 570.5Z",
    stroke: "#528CC1",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "#1E2945",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 11,
    transform: "translate(768.702 587)"
  }, "HR &amp; Admin"), /*#__PURE__*/React.createElement("path", {
    d: "M850.5 571.5 926.5 571.5 926.5 598.5 850.5 598.5 850.5 571.5Z",
    stroke: "#528CC1",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "#1E2945",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 11,
    transform: "translate(869.999 588)"
  }, "Finance"), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 0.0151181 25.7869",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 -1 796.5 559.287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 191.004 0.471181",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 -1 697.5 559.971)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.5 559.5 888.5 570.06",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.5 559.5 698.5 570.06",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.5 569.5 743.5 569.5 743.5 596.5 667.5 596.5 667.5 569.5Z",
    stroke: "#528CC1",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "#1E2945",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 11,
    transform: "translate(700.803 586)"
  }, "IT"), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 292.5 345.5 292.5 345.5 319.5 256.5 319.5 256.5 292.5Z",
    stroke: "#528CC1",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "#1E2945",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 11,
    transform: "translate(261 308)"
  }, "Sharia Assurance"), /*#__PURE__*/React.createElement("path", {
    d: "M299.5 276.5 299.5 291.594",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.5 505.5 831.5 505.5 831.5 532.5 755.5 532.5 755.5 505.5Z",
    stroke: "#528CC1",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "#1E2945",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 11,
    transform: "translate(759.255 516)"
  }, "Chief Financial ", /*#__PURE__*/React.createElement("tspan", {
    fontSize: 11,
    x: 17.8333,
    y: 12
  }, "Officer")), /*#__PURE__*/React.createElement("path", {
    d: "M265.5 505.5 426.5 505.5 426.5 530.5 265.5 530.5 265.5 505.5Z",
    stroke: "#528CC1",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "#1E2945",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 11,
    transform: "translate(287.75 520)"
  }, "Investment Analysis Unit"), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 103.862 0.000104987",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    strokeDasharray: "1.33333 1.33333",
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 724.362 406.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.5 559.5 796.5 570.06",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.5 392.5 810.5 392.5 810.5 420.5 723.5 420.5 723.5 392.5Z",
    stroke: "#528CC1",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "#1E2945",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 11,
    transform: "translate(729.542 409)"
  }, "Internal Auditor"), /*#__PURE__*/React.createElement("path", {
    d: "M715.5 292.5 822.5 292.5 822.5 322.5 715.5 322.5 715.5 292.5Z",
    stroke: "#528CC1",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "#1E2945",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 11,
    transform: "translate(728.909 310)"
  }, "Audit Committee"), /*#__PURE__*/React.createElement("path", {
    d: "M822.5 338.5 929.5 338.5 929.5 365.5 822.5 365.5 822.5 338.5Z",
    stroke: "#528CC1",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "#1E2945",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 11,
    transform: "translate(847.417 348)"
  }, "Governance ", /*#__PURE__*/React.createElement("tspan", {
    fontSize: 11,
    x: -0.246704,
    y: 12
  }, "Department")), /*#__PURE__*/React.createElement("path", {
    d: "M325.5 140.5 802.5 140.5 802.5 189.5 325.5 189.5 325.5 140.5Z",
    stroke: "#528CC1",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "#F77921",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 29,
    transform: "translate(455.309 173)"
  }, "Board of Directors"), /*#__PURE__*/React.createElement("path", {
    d: "M225.5 392.5 288.5 392.5 288.5 419.5 225.5 419.5 225.5 392.5Z",
    stroke: "#528CC1",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "#1E2945",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 11,
    transform: "translate(234.624 408)"
  }, "Secretary"), /*#__PURE__*/React.createElement("path", {
    d: "M498.5 392.5 620.5 392.5 620.5 419.5 498.5 419.5 498.5 392.5Z",
    stroke: "#528CC1",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "#1E2945",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 11,
    transform: "translate(549.222 409)"
  }, "CEO"), /*#__PURE__*/React.createElement("path", {
    d: "M606.5 419.5 606.5 442.832",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    strokeDasharray: "1.33333 1.33333",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 576.716 0.934383",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 -1 298.5 276.434)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 0.000104987 17.3328",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 -1 767.5 291.833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 0.000104987 65.123",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 -1 875.5 339.623)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.5 488.5 796.421 488.673",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.5 392.48 242.5 164.5",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 0.000104987 68.3842",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 -1 559.5 487.884)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.5 486.5 559.5 503.382",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.5 487.5 796.5 504.382",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.5 165.5 325.253 165.5",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.5 408.5 498.157 408.5",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 1544 0 1544 868.499 0 868.499Z",
    fill: "#FFFFFF",
    transform: "matrix(1.22174 0 0 1 -196.778 -119.77)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 0.0643332 88.0468",
    stroke: "#5B9BD5",
    strokeWidth: 1.60833,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1.22174 0 0 -1 934.303 354.879)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.702 352.828 842.565 352.828 842.565 389.015 714.702 389.015 714.702 352.828Z",
    stroke: "#528CC1",
    strokeWidth: 1.60833,
    strokeMiterlimit: 8,
    fill: "#1E2945",
    fillRule: "evenodd",
    transform: "matrix(1.22174 0 0 1 -196.778 -119.77)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 11,
    transform: "matrix(1.47372 0 0 1.20625 711.947 247)"
  }, "Nom ", /*#__PURE__*/React.createElement("tspan", {
    fontSize: 11,
    x: 24,
    y: 0
  }, "&amp; "), /*#__PURE__*/React.createElement("tspan", {
    fontSize: 11,
    x: 34,
    y: 0
  }, "Rem "), /*#__PURE__*/React.createElement("tspan", {
    fontSize: 11,
    x: 2.07998,
    y: 11.6062
  }, "Committee"), /*#__PURE__*/React.createElement("tspan", {
    fontWeight: 700,
    fontSize: 20,
    x: -569.768,
    y: -193.161
  }, "FALCOM Holding Organization Structure")), /*#__PURE__*/React.createElement("path", {
    d: "M1057.28 440.884 1057.28 534.836",
    stroke: "#5B9BD5",
    strokeWidth: 1.60833,
    strokeMiterlimit: 8,
    strokeDasharray: "1.60833 1.60833",
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1.22174 0 0 1 -196.778 -119.77)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.59 534.971 1058.42 534.971",
    stroke: "#5B9BD5",
    strokeWidth: 1.60833,
    strokeMiterlimit: 8,
    strokeDasharray: "1.60833 1.60833",
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1.22174 0 0 1 -196.778 -119.77)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 0.00012664 20.9077",
    stroke: "#5B9BD5",
    strokeWidth: 1.60833,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1.22174 0 0 -1 748.615 233.459)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.415 352.828 656.802 352.828 656.802 389.015 543.415 389.015 543.415 352.828Z",
    stroke: "#528CC1",
    strokeWidth: 1.60833,
    strokeMiterlimit: 8,
    fill: "#1E2945",
    fillRule: "evenodd",
    transform: "matrix(1.22174 0 0 1 -196.778 -119.77)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 11,
    transform: "matrix(1.47372 0 0 1.20625 477.794 247)"
  }, "Strategic Planning ", /*#__PURE__*/React.createElement("tspan", {
    fontSize: 11,
    x: 14.7466,
    y: 10.7772
  }, "Committee")), /*#__PURE__*/React.createElement("path", {
    d: "M600.109 350.8 600.109 332.322",
    stroke: "#5B9BD5",
    strokeWidth: 1.60833,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1.22174 0 0 1 -196.778 -119.77)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 0.00012664 245.538",
    stroke: "#5B9BD5",
    strokeWidth: 1.60833,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1.22174 0 0 -1 627.769 353.146)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.759 589.253 416.759 609.616",
    stroke: "#5B9BD5",
    strokeWidth: 1.60833,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1.22174 0 0 1 -196.778 -119.77)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.09 351.622 526.528 351.622 526.528 387.809 442.09 387.809 442.09 351.622Z",
    stroke: "#528CC1",
    strokeWidth: 1.60833,
    strokeMiterlimit: 8,
    fill: "#1E2945",
    fillRule: "evenodd",
    transform: "matrix(1.22174 0 0 1 -196.778 -119.77)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 11,
    transform: "matrix(1.47372 0 0 1.20625 361.665 246)"
  }, "Executive ", /*#__PURE__*/React.createElement("tspan", {
    fontSize: 11,
    x: -3.75333,
    y: 11.6062
  }, "Committee")), /*#__PURE__*/React.createElement("path", {
    d: "M484.309 350.131 484.309 331.115",
    stroke: "#5B9BD5",
    strokeWidth: 1.60833,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1.22174 0 0 1 -196.778 -119.77)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.853 608.553 720.734 608.553 720.734 641.121 627.853 641.121 627.853 608.553Z",
    stroke: "#528CC1",
    strokeWidth: 1.60833,
    strokeMiterlimit: 8,
    fill: "#1E2945",
    fillRule: "evenodd",
    transform: "matrix(1.22174 0 0 1 -196.778 -119.77)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 11,
    transform: "matrix(1.47372 0 0 1.20625 608.942 500)"
  }, "Legal ", /*#__PURE__*/React.createElement("tspan", {
    fontSize: 11,
    x: -16.2534,
    y: 12.4352
  }, "Department")), /*#__PURE__*/React.createElement("path", {
    d: "M916.146 688.165 1006.61 688.165 1006.61 720.734 916.146 720.734 916.146 688.165Z",
    stroke: "#528CC1",
    strokeWidth: 1.60833,
    strokeMiterlimit: 8,
    fill: "#1E2945",
    fillRule: "evenodd",
    transform: "matrix(1.22174 0 0 1 -196.778 -119.77)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 11,
    transform: "matrix(1.47372 0 0 1.20625 936.075 588)"
  }, "HR &amp; ", /*#__PURE__*/React.createElement("tspan", {
    fontSize: 11,
    x: 25,
    y: 0
  }, "Admin")), /*#__PURE__*/React.createElement("path", {
    d: "M1025.91 689.371 1117.59 689.371 1117.59 721.94 1025.91 721.94 1025.91 689.371Z",
    stroke: "#528CC1",
    strokeWidth: 1.60833,
    strokeMiterlimit: 8,
    fill: "#1E2945",
    fillRule: "evenodd",
    transform: "matrix(1.22174 0 0 1 -196.778 -119.77)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 11,
    transform: "matrix(1.47372 0 0 1.20625 1085.36 590)"
  }, "Finance"), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 0.0182362 31.1054",
    stroke: "#5B9BD5",
    strokeWidth: 1.60833,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1.22174 0 0 -1 977.041 554.869)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 230.398 0.568362",
    stroke: "#5B9BD5",
    strokeWidth: 1.60833,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1.22174 0 0 -1 831.143 555.694)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1071.75 674.896 1071.75 687.634",
    stroke: "#5B9BD5",
    strokeWidth: 1.60833,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1.22174 0 0 1 -196.778 -119.77)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.565 674.896 842.565 687.634",
    stroke: "#5B9BD5",
    strokeWidth: 1.60833,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1.22174 0 0 1 -196.778 -119.77)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.171 686.959 896.846 686.959 896.846 719.527 805.171 719.527 805.171 686.959Z",
    stroke: "#528CC1",
    strokeWidth: 1.60833,
    strokeMiterlimit: 8,
    fill: "#1E2945",
    fillRule: "evenodd",
    transform: "matrix(1.22174 0 0 1 -196.778 -119.77)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 11,
    transform: "matrix(1.47372 0 0 1.20625 836.011 587)"
  }, "IT"), /*#__PURE__*/React.createElement("path", {
    d: "M309.403 352.828 416.759 352.828 416.759 385.397 309.403 385.397 309.403 352.828Z",
    stroke: "#528CC1",
    strokeWidth: 1.60833,
    strokeMiterlimit: 8,
    fill: "#1E2945",
    fillRule: "evenodd",
    transform: "matrix(1.22174 0 0 1 -196.778 -119.77)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 11,
    transform: "matrix(1.47372 0 0 1.20625 187.863 252)"
  }, "Sharia Assurance"), /*#__PURE__*/React.createElement("path", {
    d: "M361.272 333.528 361.272 351.735",
    stroke: "#5B9BD5",
    strokeWidth: 1.60833,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1.22174 0 0 1 -196.778 -119.77)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M911.321 609.759 1003 609.759 1003 642.328 911.321 642.328 911.321 609.759Z",
    stroke: "#528CC1",
    strokeWidth: 1.60833,
    strokeMiterlimit: 8,
    fill: "#1E2945",
    fillRule: "evenodd",
    transform: "matrix(1.22174 0 0 1 -196.778 -119.77)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 11,
    transform: "matrix(1.47372 0 0 1.20625 922.153 503)"
  }, "Chief Financial ", /*#__PURE__*/React.createElement("tspan", {
    fontSize: 11,
    x: 17.8333,
    y: 11.6062
  }, "Officer")), /*#__PURE__*/React.createElement("path", {
    d: "M320.259 609.759 514.465 609.759 514.465 639.915 320.259 639.915 320.259 609.759Z",
    stroke: "#528CC1",
    strokeWidth: 1.60833,
    strokeMiterlimit: 8,
    fill: "#1E2945",
    fillRule: "evenodd",
    transform: "matrix(1.22174 0 0 1 -196.778 -119.77)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 11,
    transform: "matrix(1.47372 0 0 1.20625 227.285 507)"
  }, "Investment Analysis Unit"), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 125.283 0.00012664",
    stroke: "#5B9BD5",
    strokeWidth: 1.60833,
    strokeMiterlimit: 8,
    strokeDasharray: "1.60833 1.60833",
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(-1.22174 0 0 1 870.73 370.57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960.777 674.896 960.777 687.634",
    stroke: "#5B9BD5",
    strokeWidth: 1.60833,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1.22174 0 0 1 -196.778 -119.77)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.721 473.453 977.665 473.453 977.665 507.228 872.721 507.228 872.721 473.453Z",
    stroke: "#528CC1",
    strokeWidth: 1.60833,
    strokeMiterlimit: 8,
    fill: "#1E2945",
    fillRule: "evenodd",
    transform: "matrix(1.22174 0 0 1 -196.778 -119.77)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 11,
    transform: "matrix(1.47372 0 0 1.20625 878.364 374)"
  }, "Internal Auditor"), /*#__PURE__*/React.createElement("path", {
    d: "M863.071 352.828 992.14 352.828 992.14 389.015 863.071 389.015 863.071 352.828Z",
    stroke: "#528CC1",
    strokeWidth: 1.60833,
    strokeMiterlimit: 8,
    fill: "#1E2945",
    fillRule: "evenodd",
    transform: "matrix(1.22174 0 0 1 -196.778 -119.77)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 11,
    transform: "matrix(1.47372 0 0 1.20625 877.431 254)"
  }, "Audit Committee"), /*#__PURE__*/React.createElement("path", {
    d: "M992.14 408.315 1121.21 408.315 1121.21 440.884 992.14 440.884 992.14 408.315Z",
    stroke: "#528CC1",
    strokeWidth: 1.60833,
    strokeMiterlimit: 8,
    fill: "#1E2945",
    fillRule: "evenodd",
    transform: "matrix(1.22174 0 0 1 -196.778 -119.77)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 11,
    transform: "matrix(1.47372 0 0 1.20625 1052.08 300)"
  }, "Governance ", /*#__PURE__*/React.createElement("tspan", {
    fontSize: 11,
    x: -0.246754,
    y: 11.6062
  }, "Department")), /*#__PURE__*/React.createElement("path", {
    d: "M392.634 169.478 968.015 169.478 968.015 228.584 392.634 228.584 392.634 169.478Z",
    stroke: "#528CC1",
    strokeWidth: 1.60833,
    strokeMiterlimit: 8,
    fill: "#F77921",
    fillRule: "evenodd",
    transform: "matrix(1.22174 0 0 1 -196.778 -119.77)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 29,
    transform: "matrix(1.47372 0 0 1.20625 474.221 89)"
  }, "Board of Directors"), /*#__PURE__*/React.createElement("path", {
    d: "M272.009 473.453 348.003 473.453 348.003 506.021 272.009 506.021 272.009 473.453Z",
    stroke: "#528CC1",
    strokeWidth: 1.60833,
    strokeMiterlimit: 8,
    fill: "#1E2945",
    fillRule: "evenodd",
    transform: "matrix(1.22174 0 0 1 -196.778 -119.77)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 11,
    transform: "matrix(1.47372 0 0 1.20625 148.992 372)"
  }, "Secretary"), /*#__PURE__*/React.createElement("path", {
    d: "M601.315 473.453 748.477 473.453 748.477 506.021 601.315 506.021 601.315 473.453Z",
    stroke: "#528CC1",
    strokeWidth: 1.60833,
    strokeMiterlimit: 8,
    fill: "#1E2945",
    fillRule: "evenodd",
    transform: "matrix(1.22174 0 0 1 -196.778 -119.77)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 11,
    transform: "matrix(1.47372 0 0 1.20625 612.622 374)"
  }, "CEO"), /*#__PURE__*/React.createElement("path", {
    d: "M731.59 506.021 731.59 534.166",
    stroke: "#5B9BD5",
    strokeWidth: 1.60833,
    strokeMiterlimit: 8,
    strokeDasharray: "1.60833 1.60833",
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1.22174 0 0 1 -196.778 -119.77)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 695.663 1.1271",
    stroke: "#5B9BD5",
    strokeWidth: 1.60833,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1.22174 0 0 -1 243.128 213.678)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 0.00012664 20.9077",
    stroke: "#5B9BD5",
    strokeWidth: 1.60833,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1.22174 0 0 -1 934.303 232.253)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 0.00012664 78.5546",
    stroke: "#5B9BD5",
    strokeWidth: 1.60833,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1.22174 0 0 -1 1093.47 289.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.759 589.253 960.682 589.461",
    stroke: "#5B9BD5",
    strokeWidth: 1.60833,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1.22174 0 0 1 -196.778 -119.77)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.515 473.429 292.515 198.428",
    stroke: "#5B9BD5",
    strokeWidth: 1.60833,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1.22174 0 0 1 -196.778 -119.77)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 0.00012664 82.4884",
    stroke: "#5B9BD5",
    strokeWidth: 1.60833,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1.22174 0 0 -1 627.769 468.739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.896 586.84 674.896 607.204",
    stroke: "#5B9BD5",
    strokeWidth: 1.60833,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1.22174 0 0 1 -196.778 -119.77)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960.777 588.046 960.777 608.41",
    stroke: "#5B9BD5",
    strokeWidth: 1.60833,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1.22174 0 0 1 -196.778 -119.77)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.515 199.634 392.336 199.634",
    stroke: "#5B9BD5",
    strokeWidth: 1.60833,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1.22174 0 0 1 -196.778 -119.77)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.209 492.753 600.901 492.753",
    stroke: "#5B9BD5",
    strokeWidth: 1.60833,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1.22174 0 0 1 -196.778 -119.77)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgChartFalcomHoldingEn);
export default __webpack_public_path__ + "static/media/org_chart_falcom_holding_en.15365736a94fc367b51c282071639b8e.svg";
export { ForwardRef as ReactComponent };